// extracted by mini-css-extract-plugin
module.exports = {"value":"Nutrient_value__Bfrm1","name":"Nutrient_name___ogO_"};